import React, { FC } from 'react';
import { SystemManager } from '../../../utils/SystemManager';

const CotitularTpec: FC = () => {
  return <>{SystemManager.getSystem('tarjeta-cotitular-tpec')}</>;
};

export default CotitularTpec;
